import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getHelixUIMode, isHelixEnabled, isHelixOnlyHub } from 'utils/helix';
import { isMindsetEnabledInHub } from 'utils/mindset/isMindsetEnabledInHub';
export var SHOW_ALL = 'all';
export var SHOW_DEFAULT = 'default';
export var SHOW_CUSTOM = 'custom';
export var SUBJECT = 'subject';
export var BODY = 'body';
export var FOOTER = 'footer';
export var LINK_TEXT = 'linkText';
export var SIGNATURE = 'signature';
export var TITLE = 'title';
export var ALLOWED_TEMPLATE_FIELDS = [SUBJECT, TITLE, SIGNATURE, LINK_TEXT, FOOTER, BODY];

// every template has those fields
var BASE_FIELDS = [SUBJECT, BODY, FOOTER];
export var MAX_FIELD_LENGTHS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SUBJECT, 130), TITLE, 130), SIGNATURE, 1000), LINK_TEXT, 50), FOOTER, 500), BODY, 4000);
var HUB_NAME = '{{domain.pageTitle}}';
var HUB_URL = '{{domain.origin}}';
var SENDER_NAME = '{{author.displayName}}';
var SENDER_EMAIL = '{{author.email}}';
var RECIPIENT_NAME = '%recipient.displayName%';
var RECIPIENT_FIRST_NAME = '%recipient.first_name%';
var RECIPIENT_EMAIL = '%recipient.email%';
var RECIPIENT_INVITE_LINK = '%recipient.link%';
var CONTENT_ASSET_NAME = '{{content.assetName}}';
var CONTENT_NAME = '{{content.name}}';
var CONTENT_TITLE = '{{content.title}}';
var CONTENT_URL = '{{content.url}}';
var CONTENT_COMMENT = '{{content.comment}}';
var CONTENT_REVIEW = '{{{content.review}}}';
var CONTENT_DUE_DATE = '{{content.dueDate}}';
var MEETING_TITLE = '{{meeting.meetingTitle}}';
var MEETING_DATE = '{{meeting.meetingDate}}';
var MEETING_SUMMARY = '{{meeting.summary}}';
var MEETING_TOP_SKILL = '{{meeting.topSkill}}';
var MEETING_TOP_SKILL_NAME = '{{meeting.topSkill.name}}';
var MEETING_TOP_SKILL_SCORE = '{{meeting.topSkill.score}}';
var MEETING_TOP_SKILL_SUMMARY = '{{meeting.topSkill.summary}}';
var MEETING_TOP_SKILL_SUGGESTION = '{{meeting.topSkill.suggestion}}';
var MEETING_TOP_SKILL_URL = '{{meeting.topSkill.url}}';
var MEETING_BOTTOM_SKILL = '{{meeting.bottomSkill}}';
var MEETING_BOTTOM_SKILL_NAME = '{{meeting.bottomSkill.name}}';
var MEETING_BOTTOM_SKILL_SCORE = '{{meeting.bottomSkill.score}}';
var MEETING_BOTTOM_SKILL_SUMMARY = '{{meeting.bottomSkill.summary}}';
var MEETING_BOTTOM_SKILL_SUGGESTION = '{{meeting.bottomSkill.suggestion}}';
var MEETING_BOTTOM_SKILL_URL = '{{meeting.bottomSkill.url}}';
var WEEK_DATE = '{{week.date}}';
var WEEK_SUMMARY = '{{week.summary}}';
var WEEK_TOP_SKILL = '{{week.topSkill}}';
var WEEK_TOP_SKILL_NAME = '{{week.topSkill.name}}';
var WEEK_TOP_SKILL_SCORE = '{{week.topSkill.score}}';
var WEEK_TOP_SKILL_SUMMARY = '{{week.topSkill.summary}}';
var WEEK_TOP_SKILL_SUGGESTION = '{{week.topSkill.suggestion}}';
var WEEK_TOP_SKILL_URL = '{{week.topSkill.url}}';
var WEEK_BOTTOM_SKILL = '{{week.bottomSkill}}';
var WEEK_BOTTOM_SKILL_NAME = '{{week.bottomSkill.name}}';
var WEEK_BOTTOM_SKILL_SCORE = '{{week.bottomSkill.score}}';
var WEEK_BOTTOM_SKILL_SUMMARY = '{{week.bottomSkill.summary}}';
var WEEK_BOTTOM_SKILL_SUGGESTION = '{{week.bottomSkill.suggestion}}';
var WEEK_BOTTOM_SKILL_URL = '{{week.bottomSkill.url}}';
export var BASE_TAGS = [HUB_NAME, HUB_URL];
export var SENDER_TAGS = [SENDER_NAME, SENDER_EMAIL];
var BASE_RECIPIENT_TAGS = [RECIPIENT_NAME, RECIPIENT_FIRST_NAME, RECIPIENT_EMAIL];
export var RECIPIENT_TAGS = [].concat(BASE_RECIPIENT_TAGS, [RECIPIENT_INVITE_LINK]);
export var CONTENT_TAGS = [CONTENT_ASSET_NAME, CONTENT_NAME, CONTENT_TITLE, CONTENT_URL, CONTENT_COMMENT, CONTENT_REVIEW, CONTENT_DUE_DATE];
export var MEETING_ANALYSIS_TAGS = [MEETING_TITLE, MEETING_DATE, MEETING_SUMMARY, MEETING_TOP_SKILL, MEETING_TOP_SKILL_NAME, MEETING_BOTTOM_SKILL, MEETING_BOTTOM_SKILL_NAME];
export var WEEKLY_ANALYSIS_TAGS = [WEEK_DATE, WEEK_SUMMARY, WEEK_TOP_SKILL, WEEK_TOP_SKILL_NAME, WEEK_BOTTOM_SKILL, WEEK_BOTTOM_SKILL_NAME];
var _getHelixUIMode = getHelixUIMode(),
  showFeedback = _getHelixUIMode.showFeedback,
  showScores = _getHelixUIMode.showScores;
if (showFeedback) {
  MEETING_ANALYSIS_TAGS.push(MEETING_TOP_SKILL_SUMMARY, MEETING_TOP_SKILL_SUGGESTION, MEETING_BOTTOM_SKILL_SUMMARY, MEETING_BOTTOM_SKILL_SUGGESTION);
  WEEKLY_ANALYSIS_TAGS.push(WEEK_TOP_SKILL_SUMMARY, WEEK_TOP_SKILL_SUGGESTION, WEEK_BOTTOM_SKILL_SUMMARY, WEEK_BOTTOM_SKILL_SUGGESTION);
}
if (showScores) {
  MEETING_ANALYSIS_TAGS.push(MEETING_TOP_SKILL_SCORE, MEETING_BOTTOM_SKILL_SCORE);
  WEEKLY_ANALYSIS_TAGS.push(WEEK_TOP_SKILL_SCORE, WEEK_BOTTOM_SKILL_SCORE);
}
if (isMindsetEnabledInHub) {
  MEETING_ANALYSIS_TAGS.push(MEETING_TOP_SKILL_URL, MEETING_BOTTOM_SKILL_URL);
  WEEKLY_ANALYSIS_TAGS.push(WEEK_TOP_SKILL_URL, WEEK_BOTTOM_SKILL_URL);
}
export var ALLOWED_EMAIL_TAGS = [].concat(BASE_TAGS, SENDER_TAGS, _toConsumableArray(RECIPIENT_TAGS), CONTENT_TAGS);
if (isHelixEnabled) {
  ALLOWED_EMAIL_TAGS.push.apply(ALLOWED_EMAIL_TAGS, MEETING_ANALYSIS_TAGS.concat(WEEKLY_ANALYSIS_TAGS));
}

// FYI: ordered alphabetically by english title instead of TEMPLATE_MAP key
export var TEMPLATE_MAP = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  newUser: {
    title: 'email_template_new_user_title',
    description: 'email_template_new_user_info',
    fields: [].concat(BASE_FIELDS, [TITLE, LINK_TEXT, SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, BASE_RECIPIENT_TAGS, [RECIPIENT_INVITE_LINK])
  },
  resetPassword: {
    title: 'email_template_reset_password_title',
    description: 'email_template_reset_password_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT, SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS)
  },
  welcomeUser: {
    title: 'email_template_welcome_user_title',
    description: 'email_template_welcome_user_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: BASE_TAGS
  }
}, !isHelixOnlyHub && {
  newCommentNotificationAdmin: {
    title: 'email_template_comment_notification_admin_title',
    description: 'email_template_comment_notification_admin_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, [CONTENT_URL, CONTENT_NAME, CONTENT_COMMENT])
  }
}), {}, {
  contentRequestNotification: {
    title: 'email_template_contact_request_notification_title',
    description: 'email_template_contact_request_notification_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, [CONTENT_TITLE])
  }
}, !isHelixOnlyHub && {
  reviewNotification: {
    title: 'email_template_review_notification_title',
    description: 'email_template_review_notification_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, [CONTENT_ASSET_NAME, CONTENT_REVIEW])
  }
}), {}, {
  userImport: {
    title: 'email_template_user_import_title',
    description: 'email_template_user_import_info',
    fields: [SUBJECT, BODY]
  }
}, !isHelixOnlyHub && {
  newReplyNotificationSubscriber: {
    title: 'email_template_new_reply_title',
    description: 'email_template_new_reply_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_NAME, CONTENT_URL, CONTENT_COMMENT])
  },
  newCommentNotificationSubscriber: {
    title: 'email_template_new_comment_title',
    description: 'email_template_new_comment_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_NAME, CONTENT_URL, CONTENT_COMMENT])
  }
}), isHelixEnabled && {
  calendarDeAuthorised: {
    title: 'email_message_type_calendar_de_authorised_title',
    description: 'email_message_type_calendar_de_authorised_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT, SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, [RECIPIENT_FIRST_NAME])
  },
  meetingAnalysis: {
    title: 'email_message_type_meeting_analysis_title',
    description: 'email_message_type_meeting_analysis_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT, SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, [RECIPIENT_FIRST_NAME], MEETING_ANALYSIS_TAGS)
  },
  weeklyAnalysis: {
    title: 'email_message_type_weekly_analysis_title',
    description: 'email_message_type_weekly_analysis_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT, SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, [RECIPIENT_FIRST_NAME], WEEKLY_ANALYSIS_TAGS)
  }
}), !isHelixOnlyHub && {
  uncompletedReminder: {
    title: 'email_template_uncompleted_reminder_title',
    description: 'email_template_uncompleted_reminder_info',
    fields: BASE_FIELDS,
    overridableFields: [SUBJECT],
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_DUE_DATE])
  },
  openReminder: {
    title: 'email_template_open_reminder_title',
    description: 'email_template_open_reminder_info',
    fields: BASE_FIELDS,
    overridableFields: [SUBJECT],
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_DUE_DATE])
  },
  inactivityReminder: {
    title: 'email_template_inactivity_reminder_title',
    description: 'email_template_inactivity_reminder_info',
    fields: BASE_FIELDS,
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS)
  },
  invitationReminder: {
    title: 'email_template_invitation_reminder_title',
    description: 'email_template_invitation_reminder_info',
    fields: [].concat(BASE_FIELDS, [TITLE, LINK_TEXT, SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS, [RECIPIENT_INVITE_LINK])
  },
  autoRecommendation: {
    title: 'email_template_auto_recommendation_title',
    description: 'email_template_auto_recommendation_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT]),
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_DUE_DATE])
  },
  recommendation: {
    title: 'email_template_recommendation_title',
    description: 'email_template_recommendation_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT]),
    overridableFields: [SUBJECT],
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_DUE_DATE])
  },
  resetRecommendation: {
    title: 'email_template_reset_recommendation_title',
    description: 'email_template_reset_recommendation_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT]),
    placeholders: [].concat(BASE_TAGS)
  }
});